export const LS_TOKEN_KEY = "auth_token";
export const LS_SIGNATURE_KEY = "signature";
export const LS_BROWSER_SESSION_ID_KEY = "browserSessionId";
export const LS_CUSTOMIZATION_SET_EVENT_KEY = "customization-set";
export const LS_CUSTOMIZATION_KEY = "customization";
export const LS_SESSION_KEY = "session";
export const LS_SESSION_LANG_KEY = "lang-session";
export const LS_LANG_KEY = "lang";
export const LS_WAITING_TEXT_KEY = "waiting-text";
export const LS_FOOTPRINT_KEY = "customization-footprint";
export const LS_USER_KEY = "user";
